<template>
  <ui-modal class="modal-video" :show="modal_video_show">
    <div class="modal-mask" @click="closeVideoModal"></div>
    <xd-video
      ref="xdvideo"
      :options="modal_video_options"
      @after-create="handleCreated"
    />
    <!-- <img class="modal-close-btn" src="https://website.xdcdn.net/homepage/torchlight/imgs/mobile/section5/off.png" @click="closeVideoModal" /> -->
  </ui-modal>
</template>

<script>
import UiModal from "./ui-modal.vue";
import XdVideo from "./xdvideo.vue";
// import { mapState, mapMutations } from "vuex";

export default {
  name: "ModalVideo",
  components: { UiModal, XdVideo },
  data() {
    return {
      modal_video_options: {},
      modal_video_show: false
    }
  },
  // computed: {
  //   ...mapState(["modal_video_options", "modal_video_show"]),
  // },
  methods: {
    // ...mapMutations(["toggleModal"]),
    createModalVideo(options) {
      this.modal_video_options = options;
      this.toggleModal(true);
    },
    closeVideoModal() {
      this.toggleModal(false);
    },
    handleCreated(player) {
      player.on('fullscreenchange', (e) => {
        const isFullscreen = player.isFullscreen();
        if (!isFullscreen) {
          this.closeVideoModal();
        }
      });
      const playPromise = player.play();
      if (playPromise !== null) {
        playPromise.catch(() => {
          player.play();
        });
      }
    },
    toggleModal(bool) {
      this.modal_video_show = bool;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-video {
  display: flex;
  justify-content: center;
  align-items: center;
  .modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.modal-close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  color: #ffffff;
}
</style>